export const enabledStubDetailImageConstructor = true
export const enabledSocialImageConstructor = true
export const availableAspectRatios = [1.96, 1.5, 1, 1.9, 0.76]
